import { apiService } from "../services/api.service";
import { authenticationService } from "../services/authentication.service";
import Moment from "moment";

export const paletaController = {
    GetNeexpedovaneBaliky,
    SavePaleta
};

function GetNeexpedovaneBaliky(idPaleta) {
    return apiService.fetchApiRequest("api/Paleta/GetNeexpedovaneBaliky?idPaleta=" + idPaleta);
}

function SavePaleta(paletaId, data) {
    const currentUser = authenticationService.currentUserValue;

    data = data.map(item => ({ ...item, datum: Moment(item.datum).format() }));

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${currentUser.token}` },
        body: JSON.stringify({ paletaId, items: data })
    };

    return apiService.fetchApiRequest("api/Paleta/Save", false, requestOptions);
}



// WEBPACK FOOTER //
// ./src/controllers/paleta.controller.js